import { DividerRecord } from 'types'

import { VideoCoverRecord } from '@/components/blocks/DesignSystem/VideoCoverBlock'
import { FullWidthMediaAssetRecord } from '@/components/blocks/ModularLandingPage/FullWidthMediaAssetBlock'
import { FullWidthTextRecord } from '@/components/blocks/ModularLandingPage/FullWidthTextBlock'
import { LinkCollectionRecord } from '@/components/blocks/ModularLandingPage/LinkCollectionBlock'
import { MediaAndTextRecord } from '@/components/blocks/ModularLandingPage/MediaAndTextBlock'
import { AppDownloadSectionRecord } from '@/components/blocks/Shared/AppDownloadBlock'
import { CardsSectionRecord } from '@/components/blocks/Shared/CardsBlock'
import { ContentAndImageBlockRecord } from '@/components/blocks/Shared/ContentAndImageBlock'
import { InfoSurfaceBlockRecord } from '@/components/blocks/Shared/InfoSurfaceBlock'
import { JumboTitleRecord } from '@/components/blocks/Shared/JumboTitleBlock'
import { PodcastBlockRecord } from '@/components/blocks/Shared/PodcastBlock'
import { SwipeCardsSectionRecord } from '@/components/blocks/Shared/SwipeCardsBlock'
import { VideoFullWidthRecord } from '@/components/blocks/Shared/VideoFullWidthBlock'

import { renderModularBlocks } from '../renderModularBlocks'

type ModularLandingPageContentBlocks =
  | JumboTitleRecord
  | MediaAndTextRecord
  | FullWidthMediaAssetRecord
  | FullWidthTextRecord
  | LinkCollectionRecord
  | CardsSectionRecord
  | AppDownloadSectionRecord
  | VideoFullWidthRecord
  | VideoCoverRecord
  | CardsSectionRecord
  | DividerRecord
  | ContentAndImageBlockRecord
  | InfoSurfaceBlockRecord
  | PodcastBlockRecord
  | SwipeCardsSectionRecord

type ModularLandingPageContentProps = {
  content: ModularLandingPageContentBlocks[]
}

export const ModularLandingPageContent = ({ content }: ModularLandingPageContentProps) => {
  return <>{(content ?? []).map((record, index) => renderModularBlocks(record, index))}</>
}
